module.exports = __webpack_public_path__ + "static/img/bg-image.d8c5f5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingyun-kucun/bg-image.jpg
// module id = hI8R
// module chunks = 1